import { asArray } from '@/lib/collections';

interface SparklineProps {
  points: number[];
  color?: string;
  width?: number;
  height?: number;
}

/** Dependency-free SVG sparkline for dashboard trends. */
export default function Sparkline({ points, color = 'var(--ion-color-primary)', width = 240, height = 64 }: SparklineProps) {
  // A trend series is optional network data: render nothing rather than throwing.
  const series = asArray(points);
  if (series.length < 2) return null;
  const max = Math.max(...series, 1);
  const min = Math.min(...series, 0);
  const range = max - min || 1;
  const step = width / (series.length - 1);
  const path = series
    .map((value, index) => {
      const x = index * step;
      const y = height - ((value - min) / range) * (height - 8) - 4;
      return `${index === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');
  return (
    <svg className="sparkline" viewBox={`0 0 ${width} ${height}`} width="100%" height={height} role="img">
      <path d={path} stroke={color} />
    </svg>
  );
}
